export default __webpack_public_path__ + "static/media/leo-sunum.3ae8d606.jpg";